import { Home, User, Briefcase, Users, Inbox, MessageSquare, Airplay } from "react-feather";

export default [
  {
    id: "general",
    title: "General",
    children: [
      {
        id: "inbox",
        title: "Emails",
        icon: <Inbox size={20} />,
        navLink: "/app/inbox",
      },
    ],
  },
  {
    id: "talents",
    title: "Talents",
    children: [
      {
        id: "talents",
        title: "Talents",
        icon: <Users size={20} />,
        navLink: "/app/talents",
      },
      {
        id: "talent",
        title: "Talent",
        icon: <User size={20} />,
        navLink: "/app/talent",
        requires: ["contactId"],
      },
    ],
  },
  {
    id: "applicants",
    title: "Applicants",
    children: [
      {
        id: "listings-dashboard",
        title: "Dashboard",
        icon: <Airplay size={20} />,
        navLink: "/app/home",
      },
      {
        id: "listings",
        title: "Jobs",
        icon: <Briefcase size={20} />,
        navLink: "/app/listings",
      },
      {
        id: "listing-applicants",
        title: "Applicants",
        icon: <Users size={20} />,
        navLink: "/app/applicants",
        requires: ["listingId"],
      },
      {
        id: "applicant",
        title: "Applicant",
        icon: <User size={20} />,
        navLink: "/app/applicant",
        requires: ["listingId", "applicationId"],
      },
    ],
  },
];
